import { z } from 'zod';

/** Template keys churches can copy from the Resources page. */
export const RESOURCE_TEMPLATE_KEYS = [
  'new-member',
  'spiritual-gifts',
  'baptism',
  'scratch',
] as const;

export type ResourceTemplateKey = (typeof RESOURCE_TEMPLATE_KEYS)[number];

export const RESOURCE_COPY_FAILURE_REASONS = [
  'unauthorized',
  'unknown_template',
  'persist_failed',
  'clone_failed',
] as const;

export type ResourceCopyFailureReason =
  (typeof RESOURCE_COPY_FAILURE_REASONS)[number];

/**
 * Every event here is emitted from a tRPC `protectedProcedure`, which means a
 * verified `ctx.churchId` is always in hand — so `churchId` is REQUIRED, not
 * optional. It is not decoration: `distinctIdFor` reads it as the PostHog
 * identity, and without it each of these resolves to the literal `'unknown'`
 * and every church's Resources activity piles onto one synthetic person. That
 * was invisible while the Next server runtime had no publisher and these events
 * were dropped on the floor; it becomes the default the moment one is wired.
 */
export const resourcesSchemas = {
  /** Admin opened the Resources page. */
  'resources.page_viewed': z.object({
    churchId: z.string(),
  }),
  /** A starter / blank class was created from Resources. */
  'resources.template_copied': z.object({
    churchId: z.string(),
    courseId: z.string(),
    templateKey: z.enum(RESOURCE_TEMPLATE_KEYS),
  }),
  /** Welcome Aboard master class(es) deep-cloned into the church from Resources. */
  'resources.welcome_aboard_copied': z.object({
    churchId: z.string(),
    courseId: z.string(),
    inPersonCourseId: z.string().nullable(),
  }),
  /** Copy failed before a course existed. */
  'resources.template_copy_failed': z.object({
    churchId: z.string(),
    reason: z.enum(RESOURCE_COPY_FAILURE_REASONS),
    templateKey: z.enum(RESOURCE_TEMPLATE_KEYS).optional(),
  }),
};
